<div class="modal-confirm-container">
    <div class="text">Vous êtes sur le point de quitter cette page.</div>
    <div class="text text-small" style="margin-top: 8px">Les modifications que vous avez apportées<br>ne seront pas enregistrées et seront perdues.</div>
    <div class="confirm-controls">
        <div class="mocli-button btn btn-leave" (click)="cancel()">Reprendre l'édition</div>
        <div class="mocli-button btn btn-leave" [ngClass]="{'btn-disabled': isCompleteSubject?.value === false}" (click)="saveAndLeave()">Enregistrer et quitter</div>
        <div class="mocli-button btn btn-cancel" style="margin-top: 8px;" (click)="leave()">Quitter sans enregistrer</div>
    </div>
</div>